import React from "react";
import { Project, ProjectMedia } from "@/types";
import { ChevronDown } from "lucide-react";
import ProjectInfo from "./ProjectInfo";
import ProjectMediaCarousel from "./ProjectMediaCarousel";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { useLanguage } from "@/contexts/LanguageContext";

interface ProjectCardHeaderProps {
  project: Project;
  isOpen: boolean;
  projectMedia?: ProjectMedia[];
  onImageClick?: (index: number) => void;
  onClick?: () => void;
}

const ProjectCardHeader: React.FC<ProjectCardHeaderProps> = ({
  project,
  isOpen,
  projectMedia = [],
  onImageClick,
  onClick,
}) => {
  const isMobile = useIsMobile();
  const { t } = useLanguage();

  return (
    <div className="relative flex flex-col h-full">
      <div className="flex flex-col md:flex-row">
        <ProjectInfo project={project} />

        {projectMedia && projectMedia.length > 0 && (
          <div className="md:w-1/3">
            <ProjectMediaCarousel
              projectId={project.id}
              projectMedia={projectMedia}
              onImageClick={onImageClick}
            />
          </div>
        )}
      </div>

      <div className="flex justify-center py-4 mt-auto">
        {isMobile ? (
          <Button
            variant="outline"
            size="sm"
            className="pointer-events-auto"
            onClick={onClick}
          >
            {t("projectCardList.projectDetailsButton")}
          </Button>
        ) : (
          <ChevronDown
            className={`h-5 w-5 text-gray-500 transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        )}
      </div>
    </div>
  );
};

export default ProjectCardHeader;
